// The Javascript to open our search menu on mobile
// const searchToggle = document.querySelector("a.search-toggle")
// const searchClose = document.querySelector("a.search-btn-close")
const searchDarkBackground =  document.querySelector("div.search-dark-background")
const searchBarTag = document.querySelector("div.search-bar")


document.querySelectorAll("a.search-toggle").forEach(elem => elem.addEventListener("click",
 () => {
    searchBarTag.classList.toggle('search-open')
    searchDarkBackground.classList.toggle('visible')
    }));
  

    document.querySelectorAll("a.close-search-toggle").forEach(elem => elem.addEventListener("click",
 () => {
    searchBarTag.classList.toggle('search-open')
    searchDarkBackground.classList.toggle('visible')
        }));
    

// Here I close the search bar when I click on the dark background
searchDarkBackground.addEventListener("click", function () {
searchBarTag.classList.toggle('search-open')
searchDarkBackground.classList.toggle('visible')
})

// $(document).ready(function() {
//     let 
//     searchInputSelector = '.js-search-input',
//     searchSubmitSelector = '.js-search-submit',
//     onSearchInputKeyup = function(event) {
//         let
//         $form = $(this).closest('form'),
//         $button = $form.find(searchSubmitSelector),
//         shouldDisableButton = this.value.length === 0;

//         $button.prop('disabled', shouldDisableButton);
//     };

//     // Trigger the keyup event on page load
//     $(searchInputSelector).trigger('keyup');

//     $(document).on('keyup', searchInputSelector, onSearchInputKeyup);

//     // Add an additional event listener for input changes to handle deletion
//     $(document).on('input', searchInputSelector, onSearchInputKeyup);
// });


// document.addEventListener('DOMContentLoaded', function() {
//     const searchDarkBackground = document.querySelector("div.search-dark-background");
//     const searchBarTag = document.querySelector("div.search-bar");

//     document.querySelectorAll("a.search-toggle").forEach(elem => elem.addEventListener("click", () => {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     }));

//     document.querySelectorAll("a.close-search-toggle").forEach(elem => elem.addEventListener("click", () => {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     }));

//     searchDarkBackground.addEventListener("click", function () {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     });

//     let searchInputSelector = '.js-search-input',
//         searchSubmitSelector = '.js-search-submit',
//         onSearchInputKeyup = function(event) {
//             let $form = $(this).closest('form'),
//                 $button = $form.find(searchSubmitSelector),
//                 shouldDisableButton = this.value.length === 0;

//             $button.prop('disabled', shouldDisableButton);
//         };

//     // Trigger the keyup event on page load
//     $(searchInputSelector).trigger('keyup');

//     $(document).on('keyup', searchInputSelector, onSearchInputKeyup);
//     $(document).on('input', searchInputSelector, onSearchInputKeyup);
// });

// document.addEventListener("DOMContentLoaded", function() {
//     const searchInputSelector = '.js-search-input';
//     const searchSubmitSelector = '.js-search-submit';

//     const onSearchInputKeyup = function(event) {
//         const form = this.closest('form');
//         const button = form.querySelector(searchSubmitSelector);
//         const shouldDisableButton = this.value.trim().length === 0;

//         button.disabled = shouldDisableButton;
//     };

//     // Trigger the keyup event on page load to set the initial state
//     document.querySelectorAll(searchInputSelector).forEach(input => {
//         onSearchInputKeyup.call(input);
//     });

//     // Attach event listeners
//     document.addEventListener('keyup', function(event) {
//         if (event.target.matches(searchInputSelector)) {
//             onSearchInputKeyup.call(event.target);
//         }
//     });

//     document.addEventListener('input', function(event) {
//         if (event.target.matches(searchInputSelector)) {
//             onSearchInputKeyup.call(event.target);
//         }
//     });
// });


window.addEventListener("load", function() {
    // Selector for the search input and button
    const searchInputSelector = '.js-search-input';
    const searchSubmitSelector = '.js-search-submit';

    // Function to handle enabling/disabling the button
    const onSearchInputChange = function(event) {
        let form, button;

        if (this.closest) {
            form = this.closest('form');
        } else {
            // Fallback for browsers that don't support closest()
            form = findAncestor(this, 'form');
        }

        if (form) {
            button = form.querySelector(searchSubmitSelector);
        }

        if (button) {
            // Disable button if input is empty
            const shouldDisableButton = this.value.trim().length === 0;
            button.disabled = shouldDisableButton; 
        } else {
            console.log('Button not found'); // Debugging
        }
    };

    // Helper function to find ancestor element
    function findAncestor(el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
        return el;
    }

    // Use event delegation
    document.addEventListener('input', function(event) {
        if (event.target.matches(searchInputSelector)) {
            onSearchInputChange.call(event.target);
        }
    });

    // Check initial state on page load
    document.querySelectorAll(searchInputSelector).forEach(input => {
        onSearchInputChange.call(input);
    });

    // Textarea search field that grows downward as the query wraps
    const measureCanvas = document.createElement('canvas').getContext('2d');

    // Shrink the font continuously (down to --search-min-scale) so the query fits on one line before wrapping
    const fitFontSize = function(textarea) {
        const area = textarea.parentElement;
        area.style.setProperty('--search-scale', 1);
        if (textarea.value.length === 0) return;

        const style = getComputedStyle(textarea);
        const available = textarea.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        measureCanvas.font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
        const textWidth = measureCanvas.measureText(textarea.value).width;
        if (textWidth <= available) return;

        const minScale = parseFloat(getComputedStyle(area).getPropertyValue('--search-min-scale')) || 1;
        area.style.setProperty('--search-scale', Math.max(minScale, (available / textWidth) * 0.98));
    };

    const autosize = function(textarea) {
        fitFontSize(textarea);
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
        textarea.style.overflowY = textarea.scrollHeight > textarea.clientHeight ? 'auto' : 'hidden';
    };

    const syncClearButton = function(textarea) {
        const clear = textarea.parentElement.querySelector('.js-search-clear');
        if (clear) clear.hidden = textarea.value.length === 0;
    };

    const searchTextareas = document.querySelectorAll('textarea' + searchInputSelector);

    searchTextareas.forEach(textarea => {
        autosize(textarea);

        textarea.addEventListener('input', () => {
            if (/[\r\n]/.test(textarea.value)) {
                const caret = textarea.selectionStart;
                textarea.value = textarea.value.replace(/[\r\n]+/g, ' ');
                textarea.setSelectionRange(caret, caret);
            }
            autosize(textarea);
            syncClearButton(textarea);
        });

        textarea.addEventListener('keydown', event => {
            if (event.key !== 'Enter' || event.isComposing) return;
            event.preventDefault();
            if (textarea.value.trim().length > 0) textarea.form.requestSubmit();
        });

        const clear = textarea.parentElement.querySelector('.js-search-clear');
        if (clear) {
            clear.addEventListener('click', () => {
                textarea.value = '';
                textarea.dispatchEvent(new Event('input', { bubbles: true }));
                textarea.focus();
            });
        }
    });

    window.addEventListener('resize', () => searchTextareas.forEach(autosize));
    document.querySelectorAll('a.search-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => searchTextareas.forEach(autosize));
    });

    // Feature detection
    if (!Element.prototype.closest) {
        console.log('closest() method not supported');
    }
});
















